module.exports = __webpack_public_path__ + "static/media/camera.0b9d137e.svg";